/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_About_Pricing_LabelInputs */

const en_mk_cmp_page_about_pricing_label = /** @type {(inputs: Mk_Cmp_Page_About_Pricing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const id_mk_cmp_page_about_pricing_label = /** @type {(inputs: Mk_Cmp_Page_About_Pricing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Mk_Cmp_Page_About_Pricing_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_about_pricing_label = /** @type {((inputs?: Mk_Cmp_Page_About_Pricing_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_About_Pricing_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_about_pricing_label(inputs)
	return en_mk_cmp_page_about_pricing_label(inputs)
});